import { CategoryAreaPinComponent, LayoutPart, Size, Vector } from '../../models';
import { newBox, newSize, newVector } from '../geometry';
import { defaultOrder } from '../order';
import { randomId } from '../random-id';

type CategoryAreaPinComponentProps = {
  position?: Vector;
  size?: Size;
  layoutPart?: LayoutPart;
  order?: string;
  settings?: Partial<CategoryAreaPinComponent['settings']>;
};

export function newCategoryAreaPinComponent({
  position = newVector(32, 124),
  size = newSize(896, 384),
  order = defaultOrder,
  settings,
}: CategoryAreaPinComponentProps): CategoryAreaPinComponent {
  return {
    type: 'CATEGORY_AREA',
    id: randomId(),
    settings: {
      layoutMode: 'AUTO',
      categories: [],
      ...settings,
    },
    layout: newBox(position, size),
    order,
  };
}
